import React, { useState } from 'react'
import PropTypes from 'prop-types'
import style from './GenericHeader.scss'
import classNames from 'classnames/bind'
import { Icon, SearchBar, Modal } from '@liquid-design/liquid-design-react'
import FIlterModalContainer from 'containers/FIlterModalContainer/FIlterModalContainer'
import { FormattedMessage, injectIntl } from 'react-intl'


const cx = classNames.bind(style)

const propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  handleSubmit: PropTypes.func,
  showSearch: PropTypes.bool,
  showFilter: PropTypes.bool,
  handleSearch: PropTypes.func,
  handleApplyFilter: PropTypes.func,
  showFilters: PropTypes.bool,
  additionalElement: PropTypes.element,
  updateSearchTerm: PropTypes.func,
  defaultSearchTerm: PropTypes.string,
  intl: PropTypes.object
}

const GenericHeader = (props) => {
  const {
    title,
    handleSearch,
    placeholder,
    showSearch,
    handleApplyFilter,
    showFilters,
    additionalElement,
    defaultSearchTerm,
    updateSearchTerm,
    intl
  } = props
  const [isOpen, setIsOpen] = useState(false)
  const [search, openSearch] = useState(false)
  const handleFilter = () => {
    setIsOpen(false)
    handleApplyFilter()
  }
  const customStyles = {
    content: {
      width: '400px',
      maxHeight: '400px',
      minHeight: '200px',
      top: '17%',
      left: '48.3%',
      right: 'auto',
      bottom: 'auto',
      padding: 0,
    },
  }
  const onChangeBlur = () => {
    defaultSearchTerm === '' && openSearch(false)
  }

  const updateSearch = async (value) => {
    await updateSearchTerm(value)
    await handleSearch(value)
  } 
  return (
    <div className={cx(`${search ? 'header_bg' : 'header_bg search_icon_gray'}`)}>
      <span className={cx('header_title')}>
        {title && <FormattedMessage id={`next.${title}`} />}
      </span>
      {showSearch && search ? (
        <SearchBar
          className={'search-bar'}
          autoFocus
          onBlur={() => onChangeBlur() }
          onSubmit={(value) => updateSearch(value)}
          value={defaultSearchTerm}
          placeholder={placeholder && intl.formatMessage({ id: placeholder }) || 'Search'}
        />
      ) : (
        showSearch && (
          <Icon
            name='search'
            onClick={() => openSearch(true)}
            size={18}
          />
        )
      )}
      {showFilters && (
        <Icon
          onClick={() => setIsOpen(true)}
          className={cx('search-bar-icon',{'filter-open':isOpen})}
          name='filter'
          size={18}
        />
      )}
      <Modal
        id="filter-modal"
        isOpen={isOpen}
        label={
          <h2>
            <b>Filter by</b>
          </h2>
        }
        open={isOpen}
        reactModalProps={{
          style: customStyles,
        }}
        overlayAuxClassName={cx('modal-class')}
        onClose={() => setIsOpen(false)}
      >
        <FIlterModalContainer {...props} applyFilter={() => handleFilter()} />
      </Modal>
      {additionalElement && additionalElement}
    </div>
  )
}

GenericHeader.propTypes = propTypes
GenericHeader.defaultProps = {
  placeholder: 'Search'
}

export default injectIntl(GenericHeader)
